<template>
  <b-button outline variant="link" class="text-white scan-qr-btn" @click="onScanQrClick">
    <font-awesome-icon icon="qrcode" class=""/>
    {{ $t("Scan QR") }}
  </b-button>
</template>

<script>
  import {ON_QR_CODE_READER_MODAL_OPEN} from "@/plugins/event-bus/event-bus-names";
  import QrCodeService from "@/core/components/qr-code-generator/QrCodeService";
  import {MODEL_NAME_INVENTORY_ITEM, MODEL_NAME_ITEM_LOCATION, MODEL_NAME_RECEIPT, MODEL_NAME_INVOICE} from "@/modules/constants";
  import {createNamespacedHelpers} from "vuex";
  const {mapActions: invoiceMapActions} = createNamespacedHelpers('invoices');
  const {mapActions: mapActionsGlobal} = createNamespacedHelpers('global');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "NavbarQrScanButton",
    methods: {
      ...mapActionsGlobal(['showItemLocationMoveModal']),
      ...invoiceMapActions({
        updateTableSourceInvoice: "updateTableSource",
        updateSearchModelInvoice: "updateSearchModel",
        resetSearchModelInvoice: "resetSearchModel",
        getTableDataInvoice: "getTableData"
      }),
      onScanQrClick() {
        this.$evBus.$emit(ON_QR_CODE_READER_MODAL_OPEN, {
          handler: async (result) => {

            let response = await QrCodeService.getQrCodeInfo(result)

            let redirect = null;
            if (response.success) {
              if (response.body.result.model_type === MODEL_NAME_INVENTORY_ITEM) {
                redirect = {name: 'inventory.dashboard', params: {id: response.body.result.model_uuid}};
              } else if (response.body.result.model_type === MODEL_NAME_ITEM_LOCATION) {
                this.showItemLocationMoveModal({
                  itemLocationUuid: response.body.result.model_uuid
                })
              } else if (response.body.result.model_type === MODEL_NAME_RECEIPT) {
                redirect = {name: 'receipt.dashboard', params: {id: response.body.result.model_uuid}};
              } else if (response.body.result.model_type === MODEL_NAME_INVOICE) {
                redirect = {name: "invoices"};
                this.updateTableSourceInvoice({source: "invoices"})
                this.resetSearchModelInvoice()
                this.updateSearchModelInvoice({
                  searchModel: {
                    ...response.body.result.extra_data
                  }
                })
                if (this.$route.name === 'invoices') {
                  this.getTableDataInvoice();
                  return;
                }
              }
              if (redirect) {
                this.$router.push(redirect);
              }
            } else {
              if (response.body.non_field_errors) {
                this.$errorDialog(response.body.non_field_errors[0]);
              } else if (response.toastError) {
                this.$errorDialog(response.toastError)
              }
            }
          }
        });
      },
    },
  }
</script>

<style lang="scss" scoped>
  .scan-qr-btn {
    &:hover {
      text-decoration: none;
    }
  }
</style>
